export function replaceArrayElement<T>(
    array: T[],
    target: T,
    index: number
): T[] {
    return [...array.slice(0, index), target, ...array.slice(index + 1)];
}
